import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FlowNodeTemplateKind, IamModule } from '@fullstackagency/iam';
import { UiNodeTypeEnum } from '@ory/client';
import { IamMessagesComponent } from './messages.component';

@Component({
  selector: 'iam-content',
  template: ` <ng-template iamMessages let-m>
      <iam-messages [messages]="m" />
    </ng-template>

    <ng-template [iamTemplate]="FlowNodeTemplateKind.Anchor" let-a>
      @if(a.nodeType === UiNodeTypeEnum.A) {
      <a [href]="a.href">
        {{ a.title }}
      </a>
      }
    </ng-template>

    <ng-template [iamTemplate]="FlowNodeTemplateKind.Image">{{
      FlowNodeTemplateKind.Image
    }}</ng-template>

    <ng-template [iamTemplate]="FlowNodeTemplateKind.Input" let-a>
      @if(a.nodeType === UiNodeTypeEnum.Input) {
      <div class="space-y-1">
        <label class="text-sm font-semibold">{{ a.label }}</label>
        <input
          class="w-full rounded-xl px-4 py-3 border border-[#D6C8BE] bg-white"
          [autocomplete]="a.autocomplete"
          [disabled]="a.disabled"
          [name]="a.name"
          [required]="a.required"
          [type]="a.type"
          [value]="a.value"
        />
      </div>

      <div class="flex flex-column my-3 gap-1">
        <label></label>

        <iam-messages [messages]="a.messages" />
      </div>
      }
    </ng-template>

    <ng-template
      [iamTemplate]="[
        FlowNodeTemplateKind.InputButton,
        FlowNodeTemplateKind.InputSubmit
      ]"
      let-a
    >
      @if(a.nodeType === UiNodeTypeEnum.Input){
      <div>
        <button
          [name]="a.name"
          [type]="a.type"
          [value]="a.value"
          class="bg-[var(--orange-text-color)] text-white px-4 py-2 flex items-center gap-2 rounded-lg w-full justify-center mb-3"
        >
          {{ a.label }}
        </button>
      </div>
      }
    </ng-template>

    <ng-template [iamTemplate]="FlowNodeTemplateKind.Script">{{
      FlowNodeTemplateKind.Script
    }}</ng-template>

    <ng-template [iamTemplate]="FlowNodeTemplateKind.Text">{{
      FlowNodeTemplateKind.Text
    }}</ng-template>`,
  imports: [CommonModule, IamModule, IamMessagesComponent],
})
export class ContentComponent {
  FlowNodeTemplateKind = FlowNodeTemplateKind;
  UiNodeTypeEnum = UiNodeTypeEnum;
}
